import { Cell } from 'ui/tableCell';
import { ColumnData } from 'ui/tableHeader';
import { displayDate } from 'utils/date';
import { MetricDefinition } from '../types';
import { TableActionMenu } from './TableActionMenu';

export const highLevelMetricDefinitionsColumns = [
  {
    name: 'Metric name',
    value: 'metricName',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <div>{row.metricName}</div>
      </Cell>
    ),
  } as ColumnData,
  {
    name: 'Definition',
    value: 'definition',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <div>{row.definition}</div>
      </Cell>
    ),
  } as ColumnData,
  // {
  //   name: 'Calculation',
  //   value: 'calculation',
  //   align: 'flex-start',
  //   RowCell: ({ row }: { row: MetricDefinition }) => (
  //     <Cell>
  //       <div>{row.calculation}</div>
  //     </Cell>
  //   ),
  // } as ColumnData,
  {
    name: 'Long Definition',
    value: 'longDefinition',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <div>{row.longDefinition}</div>
      </Cell>
    ),
  } as ColumnData,
  {
    name: 'Learn More Link',
    value: 'learnMoreLink',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <a href={row.learnMoreLink} target="_blank">
          {row.learnMoreLink}
        </a>
      </Cell>
    ),
  } as ColumnData,
  {
    name: 'Created at',
    value: 'createdAt',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <div>{displayDate(row.createdAt)}</div>
      </Cell>
    ),
  } as ColumnData,
  {
    name: 'Updated at',
    value: 'updatedAt',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <div>{displayDate(row.updatedAt)}</div>
      </Cell>
    ),
  } as ColumnData,
  {
    name: 'Shown in Messaging Insights',
    value: 'isMIReportingMetric',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <div>{row.isMIReportingMetric ? 'Yes' : 'No'}</div>
      </Cell>
    ),
  } as ColumnData,
];

export const analyticsMetricDefinitionColumns = [
  ...highLevelMetricDefinitionsColumns,
  {
    name: 'Shown in Campaign Analytics',
    value: 'isCAReportingMetric',
    align: 'flex-start',
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <div>{row.isCAReportingMetric ? 'Yes' : 'No'}</div>
      </Cell>
    ),
  } as ColumnData,
];

type actionColumnProps = {
  handleEditClick: (row: MetricDefinition) => void;
  handleDeleteClick: (row: MetricDefinition) => void;
};
export const actionColumn = ({ handleEditClick, handleDeleteClick }: actionColumnProps) =>
  ({
    name: 'Actions',
    value: '',
    align: 'flex-start',
    sortable: false,
    RowCell: ({ row }: { row: MetricDefinition }) => (
      <Cell>
        <TableActionMenu
          row={row}
          handleEditClick={() => handleEditClick(row)}
          handleDeleteClick={() => handleDeleteClick(row)}
        />
      </Cell>
    ),
  }) as ColumnData;
